import Image from 'next/image'
import Link from 'next/link'
import { formatTimestampMonthDayYear } from 'src/utils'
import { getPostTopic } from 'src/utils/hygraph'
import { IPost } from '../../types/hygraph'

type IProps = {
  post: IPost
}

function BlogCard({ post }: IProps) {
  const { basePath, topic } = getPostTopic(post)
  const categoryLabel = topic?.label

  return (
    <Link
      href={`${basePath}/${post?.slug}`}
      className="group flex flex-col border-t border-ink-100/15 pt-5 transition-colors duration-200 md:pt-6"
    >
      <div className="relative aspect-[4/5] w-full overflow-hidden bg-cream-300">
        <Image
          src={post.coverImage?.url ?? ''}
          alt={post.coverImageAlt ?? ''}
          fill
          className="object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
          sizes="(max-width: 600px) 100vw, (max-width: 900px) 50vw, 33vw"
          quality={75}
        />
      </div>

      {categoryLabel && (
        <p className="mt-5 font-display text-[10px] tracking-[0.22em] text-blue-500 uppercase md:text-[11px]">
          {categoryLabel}
        </p>
      )}

      <h3 className="mt-3 line-clamp-3 font-display text-[20px] leading-[1.2] font-medium tracking-[-0.005em] text-ink-700 transition-colors duration-200 group-hover:text-blue-500 md:text-[22px]">
        {post?.title}
      </h3>

      {post?.description && (
        <p className="mt-3 line-clamp-2 text-[14px] leading-relaxed text-ink-200">
          {post.description}
        </p>
      )}

      <div className="mt-5 flex flex-wrap items-center gap-x-2 gap-y-1 text-[12px] text-ink-200">
        {post?.author?.name && (
          <span className="text-ink-700">{post.author.name}</span>
        )}
        {post?.author?.name && (post?.date ?? post?.createdAt) && (
          <span aria-hidden="true" className="text-ink-100/40">
            ·
          </span>
        )}
        {(post?.date ?? post?.createdAt) && (
          <time dateTime={post.date ?? post.createdAt}>
            {formatTimestampMonthDayYear(post.date ?? post.createdAt)}
          </time>
        )}
      </div>
    </Link>
  )
}

export default BlogCard
